import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GrammarGuideService } from './grammar-guide.service';
import { GrammarGuideList } from './GrammarGuideList';
import { GrammarGuideTopic } from './GrammarGuideTopic';

@Component({
  selector: 'lp2-grammar-guide',
  templateUrl: './grammar-guide.component.html',
  styleUrls: ['./grammar-guide.component.scss'],
})
export class GrammarGuideComponent implements OnInit {
  private static readonly GrammarListLocalStorageName: string = 'grammarList';

  @Output() openModal = new EventEmitter();

  list: GrammarGuideList;
  filter: string;
  filteredList: Array<GrammarGuideTopic>;
  modalContent: { title: ''; body: '' };
  topicUrl: SafeResourceUrl;
  modalRef: NgbModalRef;

  @ViewChild('modal') private modal;

  constructor(
    private modalService: NgbModal,
    private grammarGuideService: GrammarGuideService,
    private sanitizer: DomSanitizer
  ) {
    this.filter = '';
  }

  updateFilter(newValue) {
    this.filter = newValue;
    this.filterList();
  }

  filterList() {
    this.filteredList =
      this.list.topics && this.list.topics.filter((topic) => topic.topicName.match(new RegExp(this.filter, 'i')));
  }

  updateList(list) {
    this.list = list;
    this.filterList();
  }

  ngOnInit() {
    const localGrammarList: GrammarGuideList = this.getSessionStorage(
      GrammarGuideComponent.GrammarListLocalStorageName
    );
    if (!localGrammarList) {
      this.grammarGuideService.getList().subscribe(
        (result) => {
          this.updateList(result);
          this.setSessionStorage(GrammarGuideComponent.GrammarListLocalStorageName, result);
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      this.updateList(localGrammarList);
    }
  }

  openTopicModal(topicUrl) {
    this.topicUrl = this.sanitizer.bypassSecurityTrustResourceUrl('/guide/en_US/' + topicUrl + '.html');
    this.modalRef = this.modalService.open(this.modal, { size: 'lg', windowClass: 'grammar-guide-modal' });
    this.openModal.emit();
  }

  closeTopicModal() {
    if (!this.modalRef) {
      return;
    }
    this.modalRef.close();
  }

  private getSessionStorage(key: string) {
    const json = sessionStorage.getItem(key);
    return json ? JSON.parse(json) : null;
  }

  private setSessionStorage(key: string, list: GrammarGuideList) {
    sessionStorage.setItem(key, JSON.stringify(list));
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/grammar-guide/grammar-guide.component.ts